var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("CameraTestBase", {
        on: { stream: _vm.onStream, previewVideo: _vm.onPreviewVideo },
      }),
      _c("canvas", {
        ref: "landmarkCvs",
        staticStyle: {
          position: "absolute",
          left: "0px",
          top: "0px",
          "pointer-events": "none",
        },
      }),
      _c("div", [
        _c("div", [
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  return _vm.loadMediaPipe(!_vm.MediaPipe.run)
                },
              },
            },
            [_vm._v(_vm._s(!_vm.MediaPipe.run ? "run" : "stop") + " mediapipe")]
          ),
          _vm.MediaPipe.created
            ? _c("label", { staticClass: "info" }, [
                _c("span", [_vm._v("created")]),
                _c("span", [_vm._v(_vm._s(_vm.MediaPipe.created) + "ms")]),
              ])
            : _vm._e(),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.MediaPipe.detectTermMs,
                  expression: "MediaPipe.detectTermMs",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.MediaPipe,
                    "detectTermMs",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            _vm._l(_vm.MediaPipe.detectTermMsList, function (ms) {
              return _c("option", { key: ms, domProps: { value: ms } }, [
                _vm._v(
                  _vm._s(ms) + "ms(" + _vm._s((1000 / ms).toFixed(1)) + "frame)"
                ),
              ])
            }),
            0
          ),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.MediaPipe.runningMode,
                  expression: "MediaPipe.runningMode",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.MediaPipe,
                    "runningMode",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            [
              _c("option", { attrs: { value: "VIDEO" } }, [_vm._v("VIDEO")]),
              _c("option", { attrs: { value: "IMAGE" } }, [_vm._v("IMAGE")]),
            ]
          ),
          _c(
            "span",
            { style: { color: _vm.MediaPipe.detected ? "" : "red" } },
            [_vm._v("detect: " + _vm._s(_vm.MediaPipe.detected))]
          ),
        ]),
        _c("div", [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.MediaPipe.drawLandmark,
                  expression: "MediaPipe.drawLandmark",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.MediaPipe.drawLandmark)
                  ? _vm._i(_vm.MediaPipe.drawLandmark, null) > -1
                  : _vm.MediaPipe.drawLandmark,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.MediaPipe.drawLandmark,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.MediaPipe,
                          "drawLandmark",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.MediaPipe,
                          "drawLandmark",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.MediaPipe, "drawLandmark", $$c)
                  }
                },
              },
            }),
            _c("span", [_vm._v("draw landmark")]),
          ]),
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.MediaPipe.showLandmarkParts,
                  expression: "MediaPipe.showLandmarkParts",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.MediaPipe.showLandmarkParts)
                  ? _vm._i(_vm.MediaPipe.showLandmarkParts, null) > -1
                  : _vm.MediaPipe.showLandmarkParts,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.MediaPipe.showLandmarkParts,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.MediaPipe,
                          "showLandmarkParts",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.MediaPipe,
                          "showLandmarkParts",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.MediaPipe, "showLandmarkParts", $$c)
                  }
                },
              },
            }),
            _c("span", [_vm._v("show landmark parts")]),
          ]),
        ]),
        _vm.MediaPipe.showLandmarkParts
          ? _c("div", { staticStyle: { "font-size": "12px" } }, [
              _vm._v(
                " * body parts: " + _vm._s(_vm.MediaPipe.shownBodyParts) + " "
              ),
              _c("br"),
              _vm._v(
                " * landmarks details: " +
                  _vm._s(_vm.MediaPipe.shownLandmarks) +
                  " "
              ),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticStyle: { display: "none" } }, [
        _c("button", { on: { click: _vm.startImageSegmenter } }, [
          _vm._v("create ImageSegmenter"),
        ]),
        _c("button", { on: { click: _vm.imageSegmentForVideo } }, [
          _vm._v("imageSegmente for video"),
        ]),
        _c("button", { on: { click: _vm.imageSegmentForImage } }, [
          _vm._v("imageSegmente for video"),
        ]),
      ]),
      _c("div", [
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                return _vm.loadImageSegmenter(!_vm.ImageSegment.run)
              },
            },
          },
          [
            _vm._v(
              _vm._s(!_vm.ImageSegment.run ? "run" : "stop") + " ImageSegment"
            ),
          ]
        ),
        _vm.ImageSegment.created
          ? _c("label", { staticClass: "info" }, [
              _c("span", [_vm._v("created")]),
              _c("span", [_vm._v(_vm._s(_vm.ImageSegment.created) + "ms")]),
            ])
          : _vm._e(),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.ImageSegment.detectTermMs,
                expression: "ImageSegment.detectTermMs",
              },
            ],
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.ImageSegment,
                  "detectTermMs",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          _vm._l(_vm.ImageSegment.detectTermMsList, function (ms) {
            return _c("option", { key: ms, domProps: { value: ms } }, [
              _vm._v(
                _vm._s(ms) + "ms(" + _vm._s((1000 / ms).toFixed(1)) + "frame)"
              ),
            ])
          }),
          0
        ),
        _c(
          "span",
          { style: { color: _vm.ImageSegment.detected ? "" : "red" } },
          [_vm._v("detect: " + _vm._s(_vm.ImageSegment.detected))]
        ),
        _vm.ImageSegment.lastDetected
          ? _c("span", [_vm._v(", " + _vm._s(_vm.ImageSegment.lastDetected))])
          : _vm._e(),
      ]),
      _c("div", [
        _c("canvas", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.SelfieSegmentation.drawMask,
              expression: "SelfieSegmentation.drawMask",
            },
          ],
          ref: "selfiSegmentationCvs",
          staticStyle: {
            display: "none",
            position: "absolute",
            left: "0px",
            top: "0px",
            "pointer-events": "none",
          },
        }),
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                return _vm.loadSelfieSegmentation(!_vm.SelfieSegmentation.run)
              },
            },
          },
          [
            _vm._v(
              _vm._s(!_vm.SelfieSegmentation.run ? "run" : "stop") +
                " SelfieSegmentation"
            ),
          ]
        ),
        _vm.SelfieSegmentation.created
          ? _c("label", { staticClass: "info" }, [
              _c("span", [_vm._v("created")]),
              _c("span", [
                _vm._v(_vm._s(_vm.SelfieSegmentation.created) + "ms"),
              ]),
            ])
          : _vm._e(),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.SelfieSegmentation.detectTermMs,
                expression: "SelfieSegmentation.detectTermMs",
              },
            ],
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.SelfieSegmentation,
                  "detectTermMs",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          _vm._l(_vm.SelfieSegmentation.detectTermMsList, function (ms) {
            return _c("option", { key: ms, domProps: { value: ms } }, [
              _vm._v(
                _vm._s(ms) + "ms(" + _vm._s((1000 / ms).toFixed(1)) + "frame)"
              ),
            ])
          }),
          0
        ),
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.SelfieSegmentation.worker,
                expression: "SelfieSegmentation.worker",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.SelfieSegmentation.worker)
                ? _vm._i(_vm.SelfieSegmentation.worker, null) > -1
                : _vm.SelfieSegmentation.worker,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.SelfieSegmentation.worker,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.SelfieSegmentation,
                        "worker",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.SelfieSegmentation,
                        "worker",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.SelfieSegmentation, "worker", $$c)
                }
              },
            },
          }),
          _c("span", [_vm._v("worker")]),
        ]),
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.SelfieSegmentation.drawMask,
                expression: "SelfieSegmentation.drawMask",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.SelfieSegmentation.drawMask)
                ? _vm._i(_vm.SelfieSegmentation.drawMask, null) > -1
                : _vm.SelfieSegmentation.drawMask,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.SelfieSegmentation.drawMask,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.SelfieSegmentation,
                        "drawMask",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.SelfieSegmentation,
                        "drawMask",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.SelfieSegmentation, "drawMask", $$c)
                }
              },
            },
          }),
          _c("span", [_vm._v("draw mask")]),
        ]),
        _c(
          "span",
          { style: { color: _vm.SelfieSegmentation.detected ? "" : "red" } },
          [_vm._v(", detect:" + _vm._s(_vm.SelfieSegmentation.detected))]
        ),
        _c("span", [
          _vm._v(", rate:" + _vm._s(_vm.SelfieSegmentation.personRate) + "%"),
        ]),
        _vm.SelfieSegmentation.lastDetected
          ? _c("span", [
              _vm._v(", " + _vm._s(_vm.SelfieSegmentation.lastDetected)),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }